/* eslint-disable no-underscore-dangle */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import PropTypes from 'prop-types';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Test} from './pages/test/test';
import DashboardController from './pages/dashboard/dashboard-controller/DashboardController';
import {loadHelpIntroData, loadTooltipsData} from './store/tooltips/actions';
import {
  getTheme,
  setTheme,
  setIsMobileDevice,
  getDashboardOptionsForUser,
} from './store/user/user-actions';
import {getAllDashboards} from './store/dashboard/dashboard-actions';
import ReactNotifications from 'react-notifications-component';

import './app.scss';
import {TOOLTIP_PROTAL_ID} from './components/onboarding/constants';

const LIGHT_THEME_CLASS_NAME = 'glu-themed--light';
const DARK_THEME_CLASS_NAME = 'glu-themed--dark';

class App extends PureComponent {
  componentDidMount() {
    this.props.getTheme();
    this.loadOnboardingData();

    if (window.DashboardComponent) {
      // eslint-disable-next-line no-underscore-dangle
      window.DashboardComponent._userSession.on(
        'OrganizationChange',
        (this._onOrganizationChange = this._onOrganizationChange.bind(this))
      );
    }
    this.props.getDashboardOptionsForUser();
    this.props.setIsMobileDevice(isMobile);
    this.setTheme();
  }

  _onOrganizationChange() {
    this.props.getTheme();
    this.props.getAllDashboards(this.props.queryParams);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLightThemeActive !== this.props.isLightThemeActive) {
      this.setTheme();
    }
  }

  componentWillUnmount() {
    if (
      window.DashboardComponent &&
      window.DashboardComponent._userSession &&
      typeof window.DashboardComponent._userSession.removeListener === 'function'
    ) {
      window.DashboardComponent._userSession.removeListener(
        'OrganizationChange',
        this._onOrganizationChange
      );
    }
  }

  setTheme = () => {
    if (this.props.isLightThemeActive) {
      document.body.setAttribute('themed', LIGHT_THEME_CLASS_NAME);
    } else {
      document.body.setAttribute('themed', DARK_THEME_CLASS_NAME);
    }
  };

  loadOnboardingData = () => {
    this.props.loadHelpIntroData();
    this.props.loadTooltipsData();
  };

  toggleThemeChange = () => {
    const activeTheme = document.body.getAttribute('themed');
    if (activeTheme) {
      this.props.setTheme(!this.props.isLightThemeActive);
    }
  };

  render() {
    return (
      <div className="glu-wrapper">
        <div id={TOOLTIP_PROTAL_ID} />
        <ReactNotifications />
        <Router basename="/#!/_app_/GameConsole/_s_/Dashboard/_rd_/JTdCJTdE/_ra_/">
          <Switch>
            <Route path="/test" component={Test} />
            <Route path="/dashboard" component={DashboardController} />
          </Switch>
        </Router>
      </div>
    );
  }
}

App.propTypes = {
  isLightThemeActive: PropTypes.bool.isRequired,
  getTheme: PropTypes.func.isRequired,
  setTheme: PropTypes.func.isRequired,
  loadTooltipsData: PropTypes.func.isRequired,
  getDashboardOptionsForUser: PropTypes.func.isRequired,
};

const mapStateToProps = ({userReducer: {isLightThemeActive, queryParams}}) => {
  return {
    isLightThemeActive,
    queryParams,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardOptionsForUser: () => getDashboardOptionsForUser(dispatch),
    getTheme: () => getTheme(dispatch),
    setTheme: (action) => setTheme(dispatch, action),
    loadTooltipsData: () => loadTooltipsData(dispatch),
    loadHelpIntroData: () => loadHelpIntroData(dispatch),
    setIsMobileDevice: (isMobileDevice) => setIsMobileDevice(dispatch, isMobileDevice),
    getAllDashboards: (query) => getAllDashboards(dispatch, query),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
